'use client';

import { asText, Content } from '@prismicio/client';

import { RichTextDefault } from '@preventx/prismic-services';

type WithQuoteProps = {
  slice: Content.RegionSliceWithQuote;
};

export const WithQuote = ({ slice }: WithQuoteProps) => {
  const { primary } = slice;
  const { quote, submitter } = primary;

  return (
    <figure className="flow">
      <blockquote>
        <RichTextDefault content={quote} />
      </blockquote>

      <figcaption>
        <cite>{asText(submitter)}</cite>
      </figcaption>
    </figure>
  );
};
